var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.button.action && _vm.button.action === "Modal Popup"
    ? _c(
        "a",
        {
          staticClass: "btn--modal",
          class: _vm.buttonClasses,
          attrs: { "data-id": _vm.button.linkUrl },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.openModal(_vm.button.linkUrl)
            },
          },
        },
        [_vm._v(_vm._s(_vm.button.text))]
      )
    : _vm.button.style === "App Store" || _vm.button.style === "Google Play"
    ? _c("LocaleLink", { attrs: { link: _vm.button.linkUrl } }, [
        _vm.button.style === "App Store"
          ? _c("img", {
              staticClass: "inline button--app",
              attrs: {
                src: "https://images.ctfassets.net/bx9krvy0u3sx/50MyBJwhdNzow664gbDwJU/565fdb71adf0792818b3552b877ebd3f/apple.jpg",
                alt: "app store button",
              },
            })
          : _vm.button.style === "Google Play"
          ? _c("img", {
              staticClass: "inline button--app",
              attrs: {
                src: "https://images.ctfassets.net/bx9krvy0u3sx/5zFPvFkg8o4Khh7tbfOCWe/65c273838647096655763e996bbe1c48/google.jpg",
                alt: "google play button",
              },
            })
          : _vm._e(),
      ])
    : _c(
        "LocaleLink",
        { class: _vm.buttonClasses, attrs: { link: _vm.button.linkUrl } },
        [_vm._v(_vm._s(_vm.button.text))]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }